import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useI18n } from "../i18n";
import { verifyEmail, resendVerification } from "../api/auth"; // add resend

export default function VerifyEmailPage() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const token = params.get("token") || "";

  const [status, setStatus] = useState<"idle" | "ok" | "err">("idle");
  const [error, setError] = useState<string | null>(null);
  const [resent, setResent] = useState(false);
  const email = params.get("email") || window.localStorage.getItem("is_last_email") || "";

  useEffect(() => {
    if (!token) {
      setStatus("err");
      setError("Missing token.");
      return;
    }

    void (async () => {
      try {
        await verifyEmail(token);
        setStatus("ok");
      } catch (e: any) {
        setStatus("err");
        setError(e?.message || "Verification failed");
      }
    })();
  }, [token]);

    async function onResend() {
       try {
        if (!email) {
          setError("Missing email.");
          return;
        }
        await resendVerification(email);
        setResent(true);
      } catch (e: any) {
        setError(e?.message || "Resend failed");
      }
    }

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-slate-900/80 border border-slate-800 rounded-2xl shadow-2xl p-6 space-y-4">
        <h1 className="text-lg font-semibold text-slate-50">
          {t("auth.verifyEmailTitle")}
        </h1>

        {status === "idle" && (
          <p className="text-sm text-slate-300">{t("common.loading")}</p>
        )}

        {status === "ok" && (
          <>
            <div className="text-sm text-emerald-300 bg-emerald-950/30 border border-emerald-800 rounded-lg px-3 py-2">
              {t("auth.verifyEmailSuccess")}
            </div>

            <div className="pt-2">
              <Link
                to="/login"
                className="inline-flex items-center justify-center w-full rounded-xl bg-pink-600 hover:bg-pink-500 text-white font-medium py-2"
              >
                {t("auth.continueToLogin")}
              </Link>
            </div>
          </>
        )}

        {status === "err" && (
          <>
            <div className="text-sm text-rose-400 bg-rose-950/40 border border-rose-800 rounded-lg px-3 py-2">
              {t("auth.verifyEmailFailed")} {error ? `(${error})` : ""}
            </div>

            <div className="text-sm text-slate-300">
              {resent ? t("auth.verificationResent") : t("auth.resendHint")}
            </div>

            <button
              onClick={onResend}
              className="inline-flex items-center justify-center w-full rounded-xl bg-slate-800 hover:bg-slate-700 text-slate-100 font-medium py-2"
              type="button"
              disabled={resent}
            >
              {t("auth.resendVerification")}
            </button>
          </>
        )}

        <div className="pt-2">
          <Link to="/login" className="text-pink-300 hover:text-pink-200 font-medium text-sm">
            {t("auth.backToLogin")}
          </Link>
        </div>
      </div>
    </div>
  );
}
